if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


//carry images
function get_accomodations_image(id, data, cont) {
    let markup = ``;
    markup += `<div class="accommodation-item__image">
                    <div class="accomodations-slides" data-slick='{"arrows": true, "dots": false, "speed": 500, "fade": true, "accessibility": false, "infinite": true, "responsive": [{"breakpoint":600,"settings":{"arrows": false}}]}'>`
    for (let index in data) {
        let image = data[index];
        markup += `<a href="${image.full_size}"  class="fancybox slide" rel="room-images-${id}">
                                                    <img src="${image.cropped}" alt="${image.alt}" class="rellax-ajax" data-rellax-speed="-2.5" data-rellax-percentage="0.5">
                                                </a>`
    }
    markup += `</div>
                </div>`;

    return markup;
}
//sorting the accomodations
function get_accommodations_markup($selector, rooms) {
    console.log(rooms);

    let markup = "";
    let $r = 0;
    for (let index in rooms) {
        let room = rooms[index];
        $r++;
        markup += `
                <div class="accommodation-item" id="room-${room.room_id}">
                    <div class="container">
                        <div class="flex-layout align-items-center accommodation-item__flex">
                          ${get_accomodations_image(room.room_id, room.image, $r)}
                          <div class="accommodation-item__text 2">
                            <h3>${room.type}</h3>
                            <h2>${room.name}</h2>
                            ${(room.rating != '') ?
                `<div class="stars">
                              <div class="stars__inner" style="width:${20 * room.rating}%">${room.rating}</div>
                            </div>`
                : ''
            }
                            <p>${room.content}</p>
                            <ul class="amenities">
                                ${room.amenities == '<li></li>' ? '' : room.amenities}
                            </ul>
                            <a href="${room.link}" target="_blank" class="accommodation-item__link">${room.link_label}</a>
                            <div class="accommodation-item__cta">
                                ${(room.type != '' && room.type == "Restaurant") ?
                (room.booking != '') ? '<a href="' + room.booking + '" class="btn" target="_blank">RESERVE</a>' : ''
                :
                (room.booking != '') ? '<a href="' + room.booking + '" class="btn">BOOK NOW</a>' : ''
            }

                                ${(room.subtitle == 'newHotel') ? '' : `<a aria-label="Learn more about ${room.name}" href="${room.url}" class="btn">LEARN MORE</a>`}

                            </div>
                          </div>
                        </div>
                    </div>
                </div>`;

    }
    $selector.html(markup);
    $(".accomodations-slides").slick();

}


function filter_by_name(data, _filter = "") {
    let result = data.filter(room =>
        (room.tags.includes(_filter[0]) && room.tags.includes(_filter[1])) ||
        (room.tags.includes(_filter[0]) && _filter[1] == '') ||
        (_filter[0] == '' && room.tags.includes(_filter[1])) ||
        (_filter[0] == '' && _filter[1] == '')
    );
    return result;
}


(function () {

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick();

    //ROOMS CALL
    let rooms_data = [];

    const $room_container = $(".rooms-content");

    $.post(`${site_url}ajax/functions.php`, {
        operation: "getAllInfoRoomsByTag",
    }, function (data) {
        let rooms = JSON.parse(data);
        rooms.forEach(function (room) {
            let roomArray = room.tags.split(',');
            room.tags = roomArray;
        });
        get_accommodations_markup($room_container, rooms);

        function checkSelects() {
            var allVals = $('.test_select').map(function () {
                return this.value;
            }).get();
            let test = filter_by_name(rooms, allVals);
            if (test == false) {
                $room_container.html('<div class="no-results text-center">No results for this filter</div>')
            } else {
                get_accommodations_markup($room_container, test);
            }
        }

        $('.test_select').change(function () {
            checkSelects();
        });

        function getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    var selectId = document.getElementById(variable);
                    selectId.value = pair[1];
                    checkSelects();
                }
            }
        }

        checkSelects();

        getQueryVariable('filter-type');


        return rooms_data = rooms;

    });



    //specials filter
    const specialsFilter = document.getElementById('specials-filter__select');
    const specials_wrapper = document.getElementById('specials__wrapper');
    if (specialsFilter) {
        function loadMainSpecial(container) {
            container.classList.add('has-preloader');
            fetch(`${site_url}ajax/functions.php?operation=getMainSpecial`, { method: "POST" })
                .then((resp) => resp.json()) // Transform the data into json
                .then((data) => {
                    container.innerHTML = data.html; //set data response via fetch in the container
                    container.classList.remove('has-preloader');
                });
        }

        function loadSpecials(container, selectVal) {
            container.classList.add('has-preloader');
            fetch(`${site_url}ajax/functions.php?operation=getSitesSpecials&siteId=` + selectVal, { method: "GET" })
                .then((resp) => resp.json()) // Transform the data into json
                .then((data) => {
                    container.innerHTML = data.html; //set data response via fetch in the container
                    setTimeout(function () {
                        $('.specials-slider').slick({
                            fade: true
                        });
                    }, 10);
                    container.classList.remove('has-preloader');
                });
        }

        loadMainSpecial(specials_wrapper);



        specialsFilter.addEventListener('change', function () {
            let thisVal = specialsFilter.value;
            if (thisVal == '') {
                loadMainSpecial(specials_wrapper);
            } else {
                loadSpecials(specials_wrapper, thisVal);
            }
        });

    }

    $('#frmContact_yes-signup-form').addClass('required');


    $('.history__slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        infinite: false,
        variableWidth: true,
        accessibility: true
    });

    $('.instagram-gallery__slider').slick({
        fade: true,
        accessibility: true
    });

})();

/** ADA Function to modify Menu **/

document.addEventListener('DOMContentLoaded', () => {
	const skipSelectors = [
		'.privary-navigation__item a'
	];


	skipSelectors.forEach(selector => {
		const elements = document.querySelectorAll(selector);
		if (elements.length > 0) {
			elements.forEach(element => {
				element.setAttribute('tabindex', '-1');
			});
		}
	});
});

/** ADA Tab Links Functionality for Keyboard Navigation **/


document.addEventListener('DOMContentLoaded', () => {
    // Variables for the navigation menu
    const menuBtn = document.querySelector('.menu-btn.js-menu-btn');
    const navigationBox = document.getElementById('header__navigation');
    const primaryNavLinks = document.querySelectorAll('.privary-navigation__item a');

    //  Variables for the booking form
    const bookingOverlay = document.getElementById('overlay-booking');
    const closeBookingButton = document.querySelector('.overlay-booking__close');
    const openBookingButton = document.querySelector('.js-open-booking');
    const bookingSelect = document.getElementById('booking__select');
    const checkIn = document.getElementById('CheckIn');
    const checkOut = document.getElementById('CheckOut');
    const bookNowButton = document.querySelector('.btn.book-now');

    function setTabIndex(elements, value) {
        elements.forEach(el => el && el.setAttribute('tabindex', value));
    }

    function toggleClassAndTabIndex(element, className, tabIndex) {
        element.classList.toggle(className);
        setTabIndex([element, ...document.querySelectorAll('.privary-navigation__item a')], tabIndex);
    }

    function handleOutsideClick(event, container, toggleFunction) {
        if (!container.contains(event.target) && container.classList.contains('open')) {
            toggleFunction();
        }
    }

    if (menuBtn) {
        menuBtn.addEventListener('click', () => {
            const isOpen = menuBtn.classList.contains('open');
            toggleClassAndTabIndex(menuBtn, 'open', isOpen ? -1 : 0);
        });

        document.addEventListener('click', (event) => {
            handleOutsideClick(event, navigationBox, () => {
                toggleClassAndTabIndex(menuBtn, 'open', -1);
            });
        });
    }

    function updateBookingOverlay() {
        const isOpen = bookingOverlay.classList.contains('open');
        setTabIndex([bookingSelect, checkIn, checkOut, bookNowButton], isOpen ? '0' : '-1');
    }

    if (closeBookingButton) {
        closeBookingButton.addEventListener('click', () => {
            bookingOverlay.classList.remove('open');
            updateBookingOverlay();
        });
    }

    if (openBookingButton) {
        openBookingButton.addEventListener('click', () => {
            bookingOverlay.classList.add('open');
            updateBookingOverlay();
        });
    }

    if (bookingOverlay) updateBookingOverlay();
});








